import axios from 'axios';
// import util from 'util/baseUtil';

const base = function() {
  
  const CancelToken = axios.CancelToken;
  let source = CancelToken.source();


  /**
   * ajax 요청 취소
   */
  function cancelRequest() {
    source.cancel('cancel');
    source = CancelToken.source();
  }


  /**
   * 모이미 라이트 Q&A 사용 여부
   */
  async function isUsingMoemeLiteQna() {
    let response = await axios.post(`/api/main/isUsingMoemeLiteQna`, '', {cancelToken: source.token});
    return response.data;
  }


  return {
    cancelRequest: cancelRequest,
    isUsingMoemeLiteQna: isUsingMoemeLiteQna,
  }
}()


export default base;